import {useEffect, useState} from 'react';

/**
 * Custom hook to detect when the user unfocuses the browser.
 *
 * @returns {boolean} - Whether the browser is unfocused.
 */
const useBrowserUnfocus = () => {
  const [isUnfocused, setIsUnfocused] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (event) => {
      if (event.clientY <= 0 || event.clientY >= window.innerHeight) {
        setIsUnfocused(true);
      }
      if (event.clientX <= 0 || event.clientX >= window.innerWidth) {
        setIsUnfocused(true);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setIsUnfocused(true);
      }
    };

    const handleBlur = () => {
      setIsUnfocused(true);
    };

    const handleFocus = () => {
      setIsUnfocused(false);
    };

    // when the mouse leaves the window or document, we consider it unfocused

    window.addEventListener('mouseout', handleMouseLeave);
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', handleBlur);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('mouseout', handleMouseLeave);
      window.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return isUnfocused;
};

export default useBrowserUnfocus;
